import { render, staticRenderFns } from "./character-card.vue?vue&type=template&id=0c6b1f3c&scoped=true&"
import script from "./character-card.vue?vue&type=script&lang=ts&"
export * from "./character-card.vue?vue&type=script&lang=ts&"
import style0 from "./character-card.vue?vue&type=style&index=0&id=0c6b1f3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b1f3c",
  null
  
)

export default component.exports